import React from "react";
import { Box, Typography, Button, Card, CardMedia } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import img from "./img/webviweImg.png";
import Header from "../../../Header/Header";
import BoltIcon from "@mui/icons-material/Bolt"; // ⚡ icon
import TextSection from "./TextSection";
import TextSection1 from "./TextSection1";
import CardMenuSection from "./CardMenuSection";
import CardMenuSection1 from "./CardMenuSection1 ";
import WhatsBusinessAPI from "./WhatsBusinessAPI";
import ReviewPage from "./ReviewPage";
import CompanySection from "./CompanySection";
import FooterSection from "../FooterSection";

const WhatsAppWebView = () => {
  return (
    <>
      <Header />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
           backgroundImage: `url('bg2.svg')`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <Box
          sx={{
            px: { xs: 2, md: 10 },
            py: { xs: 6, md: 10 },
            display: "flex",
            width: { xl: "74%", lg: "79%", md: "90%", sm: "90%" },
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "center",
            gap: 5,
          }}
        >
          {/* Left Side Content */}
          <Box sx={{ flex: 1, order: {xs: 2, md: 1} }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: "bold",
                fontSize: { xs: "2rem", md: "3rem" },
                lineHeight: 1.2,
              }}
            >
              Maximize Engagement with <br />
              Native{" "}
              <Box component="span" sx={{ color: "#00D084" }}>
                WhatsApp Webviews
              </Box>
            </Typography>

            <Typography
              variant="body1"
              color="text.secondary"
              sx={{
                mt: 3,
                fontSize: { xs: "1rem", md: "1.3rem" },
                maxWidth: 520,
                lineHeight: 1.8,
              }}
            >
              Keep customers engaged, reduce drop-offs and drive more sales by
              seamlessly loading web pages–without leaving WhatsApp.
            </Typography>

            <Box
              sx={{
                mt: 4,
                display: "flex",
                alignItems: "center",
                gap: 1,
                fontSize: { xs: "1.2rem", md: "1.4rem" },
                color: "text.secondary",
              }}
            >
              <BoltIcon sx={{ color: "#FFC107", fontSize: 30 }} />
              <Typography component="span">
                Powered by{" "}
                <Box component="span" fontWeight="bold">
                  Official WhatsApp Business API
                </Box>
              </Typography>
            </Box>

            <Button
              variant="contained"
              sx={{
                mt: 4,
                bgcolor: "#00D084",
                color: "#fff",
                fontWeight: "bold",
                px: 3,
                py: 1.3,
                fontSize: { xs: "1rem", md: "1.1rem" },
                "&:hover": { bgcolor: "#00b96e" },
                width: { xs: "100%", md: "auto" },
                maxWidth: 300,
              }}
            >
              Talk to Sale
            </Button>
          </Box>

          {/* Right Side Image */}
          <Box sx={{ flex: 1, maxWidth: 600, width: "100%", order: {xs: 1, md: 2} }}>
            <Card
              elevation={0}
              sx={{
                boxShadow: "none",
                bgcolor: "transparent",
              }}
            >
              <CardMedia
                component="img"
                image={img}
                alt="WhatsApp Webviews"
                sx={{
                  width: "100%",
                  borderRadius: 4,
                  objectFit: "contain",
                }}
              />
            </Card>
          </Box>
        </Box>
      </Box>

      <TextSection />
      <TextSection1 />
      <CardMenuSection />
      <CardMenuSection1 />
      <WhatsBusinessAPI />
      <ReviewPage />
      <CompanySection />
      <FooterSection />
    </>
  );
};

export default WhatsAppWebView;
